export const TRANSACTIONS_LIST_FETCH_ERROR =
  'Não conseguimos carregar os dados das suas transações :(<br/>Por favor, tente novamente! Caso o erro persista, entre em contato com nosso suporte pelo chat dentro do sistema.';

export const TRANSACTION_DETAIL_FETCH_ERROR =
  'Não conseguimos carregar os dados da transação :(<br/>Por favor, tente novamente! Caso o erro persista, entre em contato com nosso suporte pelo chat dentro do sistema.';

export const TRANSACTION_EXPORT_FETCH_ERROR =
  'Não conseguimos exportar os dados das suas transações :(<br/>Por favor, tente novamente! Caso o erro persista, entre em contato com nosso suporte pelo chat dentro do sistema.';
